/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./vertical-tab.component";
var styles_VerticalTabComponent = [];
var RenderType_VerticalTabComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_VerticalTabComponent, data: {} });
export { RenderType_VerticalTabComponent as RenderType_VerticalTabComponent };
export function View_VerticalTabComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 3, "div", [], [[8, "hidden", 0]], null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n  "])), i0.ɵncd(null, 0), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isActive; _ck(_v, 0, 0, currVal_0); }); }
export function View_VerticalTabComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-vertical-tab", [], null, null, null, View_VerticalTabComponent_0, RenderType_VerticalTabComponent)), i0.ɵdid(1, 114688, null, 0, i1.VerticalTabComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var VerticalTabComponentNgFactory = i0.ɵccf("app-vertical-tab", i1.VerticalTabComponent, View_VerticalTabComponent_Host_0, { title: "title", hasError: "hasError", isActive: "isActive" }, {}, ["*"]);
export { VerticalTabComponentNgFactory as VerticalTabComponentNgFactory };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/components/vertical-tab/vertical-tab.component.ngfactory.js.pre-build-optimizer.js